export default "__VITE_ASSET__BIHcVMkV__"